import { render, staticRenderFns } from "./ActiveUserWidget.vue?vue&type=template&id=4952e096&scoped=true&"
import script from "./ActiveUserWidget.vue?vue&type=script&lang=js&"
export * from "./ActiveUserWidget.vue?vue&type=script&lang=js&"
import style0 from "./ActiveUserWidget.vue?vue&type=style&index=0&id=4952e096&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4952e096",
  null
  
)

export default component.exports